import Vue from 'vue'
import Vuex from 'vuex'

import state from '@/store/state'
import getters from "@/store/getters";
import actions from "@/store/actions";
import mutations from "@/store/mutations";

import inventory from "@/store/inventoryStore";
import users from "@/store/user";
import mhdInventory from "@/app/mhdinventory/store";
import invoices from "@/app/invoices/store";
const modules = {inventory, users, mhdInventory, invoices}

Vue.use(Vuex)

export default new Vuex.Store({
    modules,
    state,
    getters,
    actions,
    mutations
})
